import { useEffect, useState } from "react";
import { ChevronDown, History, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg, money } from "@/lib/api";

const TONS = { courtois: "Rappel", ferme: "Mise en demeure" };

const quand = (iso) => new Date(iso).toLocaleString("fr-CA", { dateStyle: "short", timeStyle: "short" });

const Item = ({ r, onDelete }) => (
  <li className="flex items-center justify-between gap-3 py-2 text-xs" data-testid={`relance-${r.id}`}>
    <span><span className="font-mono text-slate-500">{quand(r.created_at)}</span>
      <span className={`ml-2 rounded px-1.5 py-0.5 ${r.ton === "ferme" ? "bg-red-100 text-red-700" : "bg-slate-100 text-slate-700"}`}>{TONS[r.ton]}</span>
      <span className="ml-2 font-medium">{r.locataire}</span> · {r.logement} · loyer de {r.mois} · {money(r.montant)}</span>
    <Button size="icon" variant="ghost" className="h-7 w-7 text-slate-400 hover:text-red-600" onClick={() => onDelete(r)} data-testid={`relance-supprimer-${r.id}`}><Trash2 className="h-3.5 w-3.5" /></Button>
  </li>
);

export const RelancesHistorique = ({ version, onChange }) => {
  const [rows, setRows] = useState([]);
  const [ouvert, setOuvert] = useState(false);
  const load = () => api.get("/relances").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, [version]);
  const del = async (r) => {
    if (!window.confirm(`Retirer de l'historique la relance du ${quand(r.created_at)} pour ${r.locataire} ?`)) return;
    try { await api.delete(`/relances/${r.id}`); load(); onChange(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-4 border-t border-slate-100 pt-3" data-testid="relances-historique">
      <button type="button" onClick={() => setOuvert(!ouvert)} className="flex items-center gap-2 text-xs font-medium text-slate-700 hover:text-emerald-700" data-testid="relances-historique-toggle">
        <History className="h-4 w-4" />Historique des relances ({rows.length})<ChevronDown className={`h-3.5 w-3.5 transition-transform ${ouvert ? "rotate-180" : ""}`} />
      </button>
      {ouvert && (rows.length === 0 ? <p className="mt-2 text-xs text-slate-500">Aucune lettre générée pour l'instant.</p>
        : <ul className="mt-2 divide-y divide-slate-100" data-testid="relances-list">{rows.map((r) => <Item key={r.id} r={r} onDelete={del} />)}</ul>)}
    </div>
  );
};
